import { atom } from 'recoil';
import { Auction } from 'shared/types/models';

// this atom is holding auction and identify for which auction rebates dialog is open
export const rebatesDialogAuctionAtom = atom<Auction>({
  key: 'REBATES_DIALOG_AUCTION',
  default: null,
});
